import { Card, CardHeader, CardContent } from '@/components/ui/Card';

interface ExecutionLogsViewerProps {
  logs: string[];
}

export function ExecutionLogsViewer({ logs }: ExecutionLogsViewerProps) {
  return (
    <Card>
      <CardHeader title="Logs" description={`${logs.length} ligne(s)`} />
      <CardContent className="p-0">
        <div className="max-h-96 overflow-y-auto bg-neutral-100 dark:bg-neutral-950 p-4 font-mono text-xs">
          {logs.length === 0 ? (
            <p className="text-neutral-500 dark:text-neutral-600">Aucun log disponible</p>
          ) : (
            logs.map((log, i) => (
              <div key={i} className="flex gap-3 py-0.5 hover:bg-neutral-200/50 dark:hover:bg-neutral-900/50">
                <span className="w-8 shrink-0 text-right text-neutral-400 dark:text-neutral-700 select-none">{i + 1}</span>
                <span className={
                  log.toLowerCase().includes('error') ? 'text-danger-400' :
                  log.toLowerCase().includes('warn') ? 'text-warning-500' :
                  log.toLowerCase().includes('success') ? 'text-success-500' :
                  'text-neutral-600 dark:text-neutral-400'
                }>
                  {log}
                </span>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
}
